export { default as DetalleMovimientos } from "./Detalle";
export { default as GraficaMovimientos } from "./Grafica";